import { render, staticRenderFns } from "./UiCountBadge.vue?vue&type=template&id=68f55262&scoped=true"
import script from "./UiCountBadge.vue?vue&type=script&lang=js"
export * from "./UiCountBadge.vue?vue&type=script&lang=js"
import style0 from "./UiCountBadge.vue?vue&type=style&index=0&id=68f55262&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f55262",
  null
  
)

export default component.exports